export default __webpack_public_path__ + "static/media/SH.1fee1a85.svg";